import React from 'react'
import { PieChart, Tooltip, Pie } from 'recharts'

interface IPlusRenewalTerms {
  plusRenewalTypes: {
    [key: string]: number
  }
}

const RADIAN = Math.PI / 180
const renderCustomizedLabel = (input: any) => {
  const { cx, cy, midAngle, innerRadius, outerRadius, percent, payload } = input
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5
  const x = cx + radius * Math.cos(-midAngle * RADIAN)
  const y = cy + radius * Math.sin(-midAngle * RADIAN)

  if (percent * 100 < 2) {
    return null
  }

  return (
    <text x={x} y={y} fill='white' textAnchor={x > cx ? 'start' : 'end'} dominantBaseline='central'>
      {`${payload?.name} - ${(percent * 100).toFixed(0)}%`}
    </text>
  )
}

const fillColors = ['rgb(255, 117, 0)', 'rgb(255, 184, 28)']

export const PlusRenewalTerms = (props: IPlusRenewalTerms) => {
  const plusRenewalTypes = Object.keys(props.plusRenewalTypes).map((key, index) => ({
    name: key,
    value: props.plusRenewalTypes[key],
    fill: fillColors[index]
  }))

  return (
    <>
      <PieChart width={600} height={500} title='Plus Renewal Terms'>
        <Pie
          data={plusRenewalTypes}
          dataKey='value'
          nameKey='name'
          cx='220'
          cy='200'
          outerRadius={200}
          fill='#FFF'
          label={renderCustomizedLabel}
          labelLine={false}
          innerRadius={80}
        />
        <Tooltip />
      </PieChart>
    </>
  )
}
